import { equalTo, onValue, orderByChild, query, ref } from "firebase/database";
import { create } from "zustand";
import { db, getBotRef, mapKeys } from "../lib/firebase";
import { useAuthStore } from "./auth.store";
import { Bot } from "../types/bot.type";
import { findIndex, merge } from "lodash";

interface botsState {
  bots: Bot[];
  addOrUpdateBot(botId: string, data: any): void;
  loading: boolean;
  selectedMode: string;
  setSelectedMode(mode: string): void;
}

export const useBotsStore = create<botsState>(set => ({
  bots: [],
  addOrUpdateBot: (botId, data) =>
    set(state => {
      const existingIndex = state.bots.findIndex(bot => bot.id === botId);
      if (existingIndex !== -1) {
        // Update existing bot
        const updatedBots = [...state.bots];
        updatedBots[existingIndex] = { ...updatedBots[existingIndex], ...data };
        return { bots: updatedBots };
      } else {
        // Add new bot
        return { bots: [...state.bots, { id: botId, ...data }] };
      }
    }),
  loading: false,
  selectedMode: "simulation",
  setSelectedMode: (mode: string) => {
    set({ selectedMode: mode });
  }
}));

useAuthStore.subscribe(authState => {
  if (!authState.user) return;
  const botsRef = ref(db, `bots/`);
  onValue(
    query(botsRef, orderByChild("user"), equalTo(authState.user.uid)),
    snapshot => {
      useBotsStore.setState({ loading: true });
      const data = snapshot.val();
      if (data) {
        // console.log(data);
        const newData = mapKeys(data);
        newData.forEach((bot: Bot) => {
          useBotsStore.setState(({ bots }) => {
            const index = findIndex(bots, { id: bot.id });
            if (index !== -1) {
              return {
                bots: updateObjectInArray(bots, bot),
                loading: false
              };
            }
            return {
              bots: addObjectToArray(bots, bot),
              loading: false
            };
          });
        });
      }
    }
  );
});

const addObjectToArray = (array: any[], obj: any) => {
  return [...array, obj];
};

const updateObjectInArray = (array: any[], object: any) =>
  array.map(obj => {
    if (obj.id === object.id) {
      // Deep merge obj and object
      return merge({}, obj, object);
    }
    return obj;
  });

export const subscribeToBot = (botId: string) => {
  // console.log("subscribing to bot", botId);
  const botRef = getBotRef(botId);
  return onValue(botRef, snapshot => {
    const bot = snapshot.val();
    if (bot) {
      bot.id = botId;
      useBotsStore.setState(({ bots }) => {
        const index = findIndex(bots, { id: botId });
        if (index !== -1) {
          return {
            bots: updateObjectInArray(bots, bot),
            loading: false
          };
        }
        return {
          bots: addObjectToArray(bots, bot),
          loading: false
        };
      });
    }
  });
};

export const modeMap: any = {
  simulation: "Simulated",
  backtest: "backtest",
  live: "live"
};
